const is = {
  array(el: any) {
    return typeof el === typeof [];
  },
};

export default is;
